module.exports = __webpack_public_path__ + "static/img/209.72ac164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/209.jpg
// module id = IQ7E
// module chunks = 0